export default {"src":"/_next/static/media/ia-logo-white.c35b0d62.svg","height":35,"width":55,"blurWidth":0,"blurHeight":0};